// import Card from 'common/components/Card/Card';
import FormControl from "common/components/FormControl/FormControl";
import FormScrollError from "common/components/FormScrollError/FormScrollError";
import UserSelect from "common/components/CustomSelect/UserSelect/UserSelect";
import RideSelect from "common/components/CustomSelect/RideSelect/RideSelect";
import SectionSelect from "common/components/CustomSelect/SectionSelect/SectionSelect";
// import useAuth from 'common/contexts/auth';
import React, { useMemo } from "react";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { FormFooter } from "common/components/FormUtilities/FormUtilities";
// import CompanySelect from 'requests/components/CompanySelect';
// import useCompanies from 'requests/contexts/companies';

function ApplicationForm({ onSubmit, data }: any) {
  const { t } = useTranslation();
  // const { user: currentUser } = useAuth();
  // const { currentCompany } = useCompanies();

  const initialValues = useMemo(
    () =>
      data?.id
        ? {
            ...data,
            user: data.user?.id,
            ride: data.ride?.id,
            section: data.section?.id,
          }
        : {
            name: "",
          },
    [data /* currentCompany */]
  );

  return (
    <Form
      onSubmit={onSubmit}
      subscription={{ values: true, submitting: true, pristine: true }}
      initialValues={initialValues}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} noValidate>
          <section className="p-8">
            <FormScrollError />
            <FormControl
              type="custom"
              name="user"
              title={t("common.user")}
              required
            >
              <UserSelect />
            </FormControl>
            <FormControl
              type="custom"
              name="ride"
              title={t("common.ride")}
              required
            >
              <RideSelect />
            </FormControl>
            <FormControl
              type="custom"
              name="section"
              title={t("common.section")}
            >
              <SectionSelect />
            </FormControl>
            <FormControl
              name="seats"
              title={t("common.seats")}
              type="number"
              required
            />
          </section>

          <FormFooter onClick={handleSubmit} />
        </form>
      )}
    />
  );
}

export default ApplicationForm;
